import React from 'react';
import {useSelector} from 'react-redux';
import {Redirect, Route, RouteComponentProps} from 'react-router-dom';
import {getUser} from '../features/auth/store/selectors';
import contextServices from '../services';
import {getPath} from './index';

interface IProps {
  path: string;
  ignoreSession?: boolean;
  component: React.FC<any>;
}

const PrivateRoute: React.FC<IProps> = ({
  component: Component,
  ignoreSession,
  ...rest
}) => {
  const user = useSelector(getUser);

  // Rotas que poderão exibir quando logado mesmo sem alterar PWD
  const allowPaths = [
    getPath('changePassword'),
    getPath('help'),
    getPath('logout'),
  ];

  const makeComp = (props: RouteComponentProps<any>) => {
    if (
      user &&
      user.required_change_pwd &&
      !allowPaths.includes(props.location.pathname)
    ) {
      return <Redirect to={{pathname: getPath('changePassword')}} />;
    }

    return <Component {...props} />;
  };

  return (
    <Route
      {...rest}
      render={props =>
        contextServices.authApi.isAuthenticated() ? (
          makeComp(props)
        ) : (
          <Redirect
            to={{pathname: getPath('auth'), state: {from: props.location}}}
          />
        )
      }
    />
  );
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.tsx